import { Form, Input } from "antd";
import { LabeledField } from "../labeledField/labeledField";

const { TextArea } = Input;

export const NotesField = ({
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const renderField = () => (
    <TextArea
      showCount
      placeholder="Enter Notes"
      maxLength={500}
      disabled={disabled}
      style={style}
      autoSize={{ minRows: 3, maxRows: 6 }}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item label="Notes" name="notes">
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Notes" extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
